import script from "./GameSign.vue?vue&type=script&setup=true&lang=js"
export * from "./GameSign.vue?vue&type=script&setup=true&lang=js"

import "./GameSign.vue?vue&type=style&index=0&id=335574ec&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-335574ec"]])

export default __exports__